import PropTypes from 'prop-types';
import React from 'react';

import './Arrow.scss';

export default class Arrow extends React.PureComponent {
    static propTypes = {
        /**
         * Direction of arrow: "up", "down", "left" or "right"
         */
        direction: PropTypes.oneOf(['up', 'down', 'left', 'right']).isRequired,
    };

    static defaultProps = {
        label: '',
    };

    render() {
        return (
            <div className="component-Elements-Arrow">
                <ul>
                    <li className={this.props.direction}></li>
                </ul>
            </div>
        );
    }
}
